<template>
    <div
        ref="rootEl"
        class="modal-container modal-container-corner no-transition"
        :class="{ hidden: !display }"
        tabindex="-1"
        role="dialog"
        :aria-hidden="!display"
        @click="close"
        @keydown="escapeToClose"
    >
        <div class="modal-dialog modal-md" role="document" @click="stopPropagationEvent">
            <div class="modal-header">
                <div class="modal-title">{{ t("Select a theme") }}</div>
                <button type="button" class="modal-close-btn" :title="t('Close')" @click="goBack">
                    <i class="fas fa-times"></i>
                </button>
            </div>

            <div class="modal-body no-padding">
                <div class="settings-list">
                    <div class="settings-list-item" tabindex="0" @keydown="clickOnEnter" @click="changeTheme('light')">
                        <div class="settings-list-item-icon" :class="{ 'check-invisible': theme !== 'light' }">
                            <i class="fas fa-check"></i>
                        </div>
                        <div class="settings-list-item-caption">{{ t("Light") }}</div>
                    </div>

                    <div class="settings-list-item" tabindex="0" @keydown="clickOnEnter" @click="changeTheme('dark')">
                        <div class="settings-list-item-icon" :class="{ 'check-invisible': theme !== 'dark' }">
                            <i class="fas fa-check"></i>
                        </div>
                        <div class="settings-list-item-caption">{{ t("Dark") }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, useTemplateRef } from "vue";
import { type ColorThemeName, getTheme, setTheme } from "@/control/app-preferences";
import { useDropdownPanel } from "@/composables/useDropdownPanel";

defineOptions({ name: "ChangeThemeDropdown" });

const display = defineModel<boolean>("display");
const emit = defineEmits<{
    openModal: [name: string];
}>();

const rootEl = useTemplateRef<HTMLElement>("rootEl");
const theme = ref(getTheme());
const { close, escapeToClose, stopPropagationEvent, clickOnEnter } = useDropdownPanel(display, rootEl, {
    onActivate: () => {
        theme.value = getTheme();
    },
});

const changeTheme = (newTheme: ColorThemeName) => {
    theme.value = newTheme;
    setTheme(newTheme);
    close();
    emit("openModal", "user-settings");
};

const goBack = () => {
    close();
    emit("openModal", "user-settings");
};
</script>

<style></style>
